module.exports = __webpack_public_path__ + "img/img46.fe2d3614.svg";